import React, { useEffect, useRef, useState } from "react";
import HeaderAction from "../components/HeaderAction";
import styled from "styled-components";
import Tab from "../components/Tab";
import ListProduct from "../components/ListProduct";
import DetailProduct from "../components/DetailProduct";
import { ID_PRIZE } from "../components/DefineData";
import iconBg1 from "../../../../assets/images/Event-2025/bg-icon-01.png";
import iconBg2 from "../../../../assets/images/Event-2025/bg-icon-2.png";
import { getDataApi } from "../../../../config/service";
import API_PATH from "../../../../config/API_PATH";
import { curStateAccount } from "../../../../Redux/selector";
import { useSelector } from "react-redux";
import PopupCongrats from "../components/Popup/PopupCongrats";
import { useNavigate } from "react-router";
import PATH from "../../../../config/PATH";
import { POPUP_VARIANT_EVENT_THINGYAN_2025 as VARIANT } from "../../../../helper/const";

export default function TakePrize({ idPrize }) {
  const selectorAccount = useSelector(curStateAccount);
  const [dataPrizeActive, setDataPrizeActive] = useState({});
  const navigate = useNavigate();
  const [itemProductActive, setItemProductActive] = useState(
    idPrize || ID_PRIZE.prize_8
  );
  const [dataAwardActive, setDataAwardActive] = useState([]);
  const [isShowPopupDetailPrize, setIsShowPopupDetailPrize] = useState(false);
  const [isRunout, setIsRunout] = useState(null);

  const handleGetDataCollected = async () => {
    const dataApi = await getDataApi(API_PATH.thingyanPieceCollected, {
      award_id: itemProductActive,
    });
    setDataAwardActive(dataApi?.data);
    setIsRunout(dataApi?.is_runout);
  };

  useEffect(() => {
    // if (selectorAccount.userInfo) {
      handleGetDataCollected();
    // }
  }, [itemProductActive, selectorAccount.userInfo]);

  const handleShowDetailItem = (dataPrize) => {
    setDataPrizeActive(dataPrize);
    setIsShowPopupDetailPrize(true);
  };

  const dataApi = {
    ...dataPrizeActive,
    idActiveProduct: itemProductActive,
    isPagePrize: true,
  };

  return (
    <Div>
      {isShowPopupDetailPrize ? (
        <PopupCongrats
          open={isShowPopupDetailPrize}
          variant={VARIANT.congratsPuzzle}
          onCancel={() => setIsShowPopupDetailPrize(false)}
          handleActionBtn={() => navigate(`${PATH.EVENT_THINGYAN}/home`)}
          getContainer={true}
          dataCongratesApi={dataApi}
        />
      ) : null}

      <Container className="container-thingyan">
        <div className="thingyan-home-header">
          <img src={iconBg1} alt="" className="icon-bg-web1" />
          <img src={iconBg2} alt="" className="icon-bg-web2" />
          <div className="header-take-prize">
            <HeaderAction />
          </div>
          <Tab />
          <ListProduct
            setItemProductActive={setItemProductActive}
            itemProductActive={itemProductActive}
          />
          <DetailProduct
            itemProductActive={itemProductActive}
            dataAwardActive={dataAwardActive}
            setDataAwardActive={setDataAwardActive}
            handleShowDetailItem={handleShowDetailItem}
            isRunout={isRunout}
          />
        </div>
      </Container>
    </Div>
  );
}
const Div = styled.div`
  .img-filter-event__2025 {
    filter: drop-shadow(0px 0px 1px white) drop-shadow(0px 0px 1px white)
      drop-shadow(0px 0px 2px white);
  }

  .text-default {
    -webkit-text-stroke: inherit !important;
    font-size: 26px !important;
  }
`;

const Container = styled.div`
  .header-take-prize {
    padding-top: 18px;
    margin-bottom: 30px;
  }

  .thingyan-home-header {
    overflow-y: hidden;
  }

  @media (max-width: 576px) {
    .header-take-prize {
      padding-top: 10px;
      margin-bottom: 20px;
    }
  }

  @media (min-width: 1400px) {
    .header-take-prize {
      padding-top: 25px;
      padding-left: 22px;
      padding-right: 22px;
    }
  }
`;
